














import Vue from "vue";

export default Vue.extend({
  data() {
    return {
      titlePageChild: "MFA Management",
      subtitlePageChild: "Configuration",
    };
  },
});
